module.exports = __webpack_public_path__ + "img/instagram.96833b9c.svg";